export default __webpack_public_path__ + "img/dbefbc28d93d2c0743d3e40edc6bdb17.svg";